<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo mb-0">Documentos</h3>

        <v-layout wrap align-center white class="area-conteudo" v-if="Array.isArray(value) && value.length > 0">
            <v-flex xs12 sm6 md4 d-flex v-for="(documento, index) in (Array.isArray(value) ? value : [])" :key="index" class="pa-1">
                <p>
                    - {{documento.documentoId | documentoNomeFilter(documentos)}}
                </p>
            </v-flex>
        </v-layout>

        <p v-else class="frase">
            Não há documentos adicionados
        </p>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelDocumentoSolicitadoVisualizacao',
    props: {
        value: {
            type: Array,
            required: false,
            default: () => []
        },
        documentos: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    filters: {
        documentoNomeFilter(docId, documentos) {
            const lista = Array.isArray(documentos) ? documentos : []
            const documentosEncontados = lista.filter(doc => doc.id === docId)
            if (documentosEncontados.length > 0) {
                return documentosEncontados[0].nome
            }
            return ''
        }
    }
}
</script>

<style scoped lang="stylus">
    .area-conteudo
        padding 16px 16px 0
        color #888

    .frase
        color #888
        font-size 13px
        padding 10px
        margin-bottom 0
</style>